import ApiService from './ApiService'

// User scoped lists
export const apiListRoles = data => ApiService.get('/user/list/roles', data)
export const apiListVendors = () => ApiService.get('/user/list/vendors')
export const apiListBankAccounts = () => ApiService.get('/user/list/bank-accounts')
export const apiListBrands = () => ApiService.get('/user/list/brands')
export const apiListCategories = id => ApiService.get(`/user/list/categories/${id}`)
export const apiListExpenses = () => ApiService.get('/user/list/expenses')
export const apiListStores = () => ApiService.get('/user/list/stores')
export const apiListCustomers = data => ApiService.get('/user/list/customers', data)
export const apiListReferrals = () => ApiService.get('/user/list/referrals')
export const apiListProducts = () => ApiService.get('/user/list/products')
export const apiListPurchases = id => ApiService.get(`/user/list/purchases/${id}`)
export const apiListStoreOrders = id => ApiService.get(`/user/list/store-orders/${id}`)
export const apiListOrders = id => ApiService.get(`/user/list/orders/${id}`)

// Roles & Permissions
export const apiPermissions = () => ApiService.get('/user/permission-datas')
export const apiRolesList = data => ApiService.get('/user/roles', data)
export const apiRolesView = id => ApiService.get(`/user/roles/${id}`)
export const apiRolesForm = (id, data) => ApiService.post(`/user/roles${id ? `/${id}` : ''}`, data)
export const apiRolesStatus = id => ApiService.post(`/user/roles/${id}/status`)

// Users
export const apiUsersList = data => ApiService.get('/user/users', data)
export const apiUsersView = id => ApiService.get(`/user/users/${id}`)
export const apiUsersForm = (id, data) => ApiService.post(`/user/users${id ? `/${id}` : ''}`, data)
export const apiUsersStatus = id => ApiService.post(`/user/users/${id}/status`)
export const apiUsersVerified = id => ApiService.post(`/user/users/${id}/verified`)

// Stores
export const apiStoresList = data => ApiService.get('/user/stores', data)
export const apiStoresView = id => ApiService.get(`/user/stores/${id}`)
export const apiStoresForm = (id, data) => ApiService.post(`/user/stores${id ? `/${id}` : ''}`, data)
export const apiStoresStatus = id => ApiService.post(`/user/stores/${id}/status`)

// Store Users
export const apiStoreUsersList = data => ApiService.get('/user/store-users', data)
export const apiStoreUsersView = id => ApiService.get(`/user/store-users/${id}`)
export const apiStoreUsersForm = (id, data) => ApiService.post(`/user/store-users${id ? `/${id}` : ''}`, data)
export const apiStoreUsersStatus = id => ApiService.post(`/user/store-users/${id}/status`)
export const apiStoreUsersVerified = id => ApiService.post(`/user/store-users/${id}/verified`)

// Bank Accounts
export const apiBankAccountsList = data => ApiService.get('/user/bank-accounts', data)
export const apiBankAccountsView = id => ApiService.get(`/user/bank-accounts/${id}`)
export const apiBankAccountsForm = (id, data) => ApiService.post(`/user/bank-accounts${id ? `/${id}` : ''}`, data)
export const apiBankAccountsStatus = id => ApiService.post(`/user/bank-accounts/${id}/status`)

// Bank Transactions
export const apiBankTransactionsList = data => ApiService.get('/user/bank-transactions', data)
export const apiBankTransactionsForm = (id, data) => ApiService.post(`/user/bank-transactions${id ? `/${id}` : ''}`, data)
export const apiBankTransactionsExport = data => ApiService.get('/user/bank-transactions-export', data)

// Wallet Transactions
export const apiWalletTransactionsList = data => ApiService.get('/user/wallet-transactions', data)
export const apiWalletTransactionsForm = (id, data) => ApiService.post(`/user/wallet-transactions${id ? `/${id}` : ''}`, data)
export const apiWalletTransactionsExport = data => ApiService.get('/user/wallet-transactions-export', data)

// Brands
export const apiBrandsList = data => ApiService.get('/user/brands', data)
export const apiBrandsView = id => ApiService.get(`/user/brands/${id}`)
export const apiBrandsForm = (id, data) => ApiService.post(`/user/brands${id ? `/${id}` : ''}`, data)
export const apiBrandsStatus = id => ApiService.post(`/user/brands/${id}/status`)

// Categories
export const apiCategoriesList = data => ApiService.get('/user/categories', data)
export const apiCategoriesView = id => ApiService.get(`/user/categories/${id}`)
export const apiCategoriesForm = (id, data) => ApiService.post(`/user/categories${id ? `/${id}` : ''}`, data)
export const apiCategoriesStatus = id => ApiService.post(`/user/categories/${id}/status`)

// Attributes
export const apiAttributesList = data => ApiService.get('/user/attributes', data)
export const apiAttributesView = id => ApiService.get(`/user/attributes/${id}`)
export const apiAttributesForm = (id, data) => ApiService.post(`/user/attributes${id ? `/${id}` : ''}`, data)
export const apiAttributesStatus = id => ApiService.post(`/user/attributes/${id}/status`)

// Expenses
export const apiExpensesList = data => ApiService.get('/user/expenses', data)
export const apiExpensesView = id => ApiService.get(`/user/expenses/${id}`)
export const apiExpensesForm = (id, data) => ApiService.post(`/user/expenses${id ? `/${id}` : ''}`, data)
export const apiExpensesStatus = id => ApiService.post(`/user/expenses/${id}/status`)

// Customers
export const apiCustomersList = data => ApiService.get('/user/customers', data)
export const apiCustomersView = id => ApiService.get(`/user/customers/${id}`)
export const apiCustomersForm = (id, data) => ApiService.post(`/user/customers${id ? `/${id}` : ''}`, data)
export const apiCustomersStatus = id => ApiService.post(`/user/customers/${id}/status`)
export const apiCustomersClear = id => ApiService.post(`/user/customers/${id}/clear`)

// Vendors
export const apiVendorsList = data => ApiService.get('/user/vendors', data)
export const apiVendorsView = id => ApiService.get(`/user/vendors/${id}`)
export const apiVendorsForm = (id, data) => ApiService.post(`/user/vendors${id ? `/${id}` : ''}`, data)
export const apiVendorsStatus = id => ApiService.post(`/user/vendors/${id}/status`)

// Referrals
export const apiReferralsList = data => ApiService.get('/user/referrals', data)
export const apiReferralsView = id => ApiService.get(`/user/referrals/${id}`)
export const apiReferralsForm = (id, data) => ApiService.post(`/user/referrals${id ? `/${id}` : ''}`, data)
export const apiReferralsStatus = id => ApiService.post(`/user/referrals/${id}/status`)

// Products
export const apiProductsList = data => ApiService.get('/user/products', data)
export const apiProductsView = id => ApiService.get(`/user/products/${id}`)
export const apiProductsForm = (id, data) => ApiService.post(`/user/products${id ? `/${id}` : ''}`, data)
export const apiProductsStatus = id => ApiService.post(`/user/products/${id}/status`)
export const apiProductsStoreStatus = (id, data) => ApiService.post(`/user/products/${id}/store-status`, data)
export const apiProductsExport = data => ApiService.get('/user/products-export', data)
export const apiProductsImport = data => ApiService.post('/user/products-import', data)

// Purchases
export const apiPurchasesProducts = data => ApiService.get('/user/purchases/products', data)
export const apiPurchasesList = data => ApiService.get('/user/purchases', data)
export const apiPurchasesView = id => ApiService.get(`/user/purchases/${id}`)
export const apiPurchasesForm = (id, data) => ApiService.post(`/user/purchases${id ? `/${id}` : ''}`, data)
export const apiPurchasesStatus = (id, data) => ApiService.post(`/user/purchases/${id}/status`, data)
export const apiPurchasesDelete = id => ApiService.destroy(`/user/purchases/${id}`)
export const apiPurchasesInvoice = id => ApiService.get(`/user/purchases/${id}/invoice`, null, { responseType: 'blob' })
export const apiPurchasesReturn = (id, data) => ApiService.post(`/user/purchases/${id}/return`, data)

// Store Orders
export const apiStoreOrdersProducts = data => ApiService.get('/user/store-orders/products', data)
export const apiStoreOrdersList = data => ApiService.get('/user/store-orders', data)
export const apiStoreOrdersView = id => ApiService.get(`/user/store-orders/${id}`)
export const apiStoreOrdersForm = (id, data) => ApiService.post(`/user/store-orders${id ? `/${id}` : ''}`, data)
export const apiStoreOrdersStatus = (id, data) => ApiService.post(`/user/store-orders/${id}/status`, data)
export const apiStoreOrdersDelete = id => ApiService.destroy(`/user/store-orders/${id}`)
export const apiStoreOrdersInvoice = id => ApiService.get(`/user/store-orders/${id}/invoice`, null, { responseType: 'blob' })
export const apiStoreOrdersReturn = (id, data) => ApiService.post(`/user/store-orders/${id}/return`, data)

// Orders
export const apiOrdersProducts = data => ApiService.get('/user/orders/products', data)
export const apiOrdersList = data => ApiService.get('/user/orders', data)
export const apiOrdersView = id => ApiService.get(`/user/orders/${id}`)
export const apiOrdersForm = (id, data) => ApiService.post(`/user/orders${id ? `/${id}` : ''}`, data)
export const apiOrdersStatus = (id, data) => ApiService.post(`/user/orders/${id}/status`, data)
export const apiOrdersDelete = id => ApiService.destroy(`/user/orders/${id}`)
export const apiOrdersInvoice = id => ApiService.get(`/user/orders/${id}/invoice`, null, { responseType: 'blob' })
export const apiOrdersReturn = (id, data) => ApiService.post(`/user/orders/${id}/return`, data)
